'use client';

import React from 'react';
import { faListTimeline } from '@fortawesome/pro-solid-svg-icons';
import { AddToListModal, PulseButton } from 'src/components';
import { useProspectSelection } from 'src/context/prospects';
import useLists from 'src/hooks/lists/useLists';

const TableMoveToListButton = ({ disabled = false, table = 'Lists' }) => {
  const [showMoveToListDialog, setShowMoveToListDialog] = React.useState(false);
  const { selectedList } = useLists();

  const {
    state: [selectedProviders],
    selectedRows: [, setRowsAreSelected],
  } = useProspectSelection();

  const toggleDialog = () => {
    setShowMoveToListDialog(!showMoveToListDialog);
  };

  const handleClose = () => {
    setRowsAreSelected(false);
    setShowMoveToListDialog(false);
  };

  const isDisabled = disabled || !selectedProviders.length;

  return (
    <>
      <PulseButton
        size="sm"
        variant="outline"
        color="neutral"
        data-testid={`${table}-move-to-list-button`}
        startDecorator={faListTimeline}
        onClick={toggleDialog}
        disabled={isDisabled}
        className="mr-2 h-9 rounded-full"
      >
        Move to List
      </PulseButton>
      <AddToListModal
        isOpen={showMoveToListDialog}
        onClose={handleClose}
        mode="move"
        providers={selectedProviders}
        sourceList={selectedList ? { id: String(selectedList.id), name: selectedList.name } : undefined}
      />
    </>
  );
};

export default TableMoveToListButton;
